





















































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ActivitiesService } from "@/services/api/activities.service";
import { Getter } from "vuex-class";
import { LanguageDto, ActivityDto, ActivityStatusDto } from "@/server/app.dtos";
import {
  GetActivityDtoQuery,
  GetActivitiesDtosIncludeOptions
} from "@/server/app.queries";
import { ISideMenuItem } from "@/models/menus/abstract/isidemenu";
import { ChangeActivityStatusCommand } from "@/server/app.commands";
import ConfigsService from "@/services/api/configs.service";
import { NotificationServiceBus } from "@/services/bus/notifications.service";

@Component
export default class ActivityDetailSharedPage extends Vue {
  activitiesService: ActivitiesService = new ActivitiesService();
  configsService: ConfigsService = new ConfigsService();
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  activity: ActivityDto | null = null;
  menus: ISideMenuItem[] = [
    {
      icon: "las la-cog",
      title: "Dashboard",
      url: "dashboard"
    },
    // {
    //   icon: "las la-cog",
    //   title: "Audiência",
    //   url: "users"
    // },
    {
      icon: "las la-cog",
      title: "Documentos",
      url: "documents"
    },
    {
      icon: "las la-cog",
      title: "Comentários",
      url: "comments"
    },
    {
      icon: "las la-stopwatch",
      title: "Log de Tempos",
      url: "log-times"
    }
  ];
  actionMenu: boolean = false;
  isLoading: boolean = false;
  activityStatus: ActivityStatusDto[] = [];

  get currentPath(): string {
    return this.$route.path;
  }

  @Watch("$route")
  onRouteChange() {
    this.Load();
  }

  async created() {
    await this.Load();
  }

  async LoadStatus() {
    await this.configsService
      .Load(
        "api/activityStatus",
        `idLanguage=${this.currentLanguage.idLanguage}&idActivityArea=${this
          .activity?.idActivityArea || ""}`
      )
      .then(data => (this.activityStatus = data));
  }

  async Load() {
    const query = new GetActivityDtoQuery();
    query.idLanguage = this.currentLanguage.idLanguage;
    query.idActivity = parseInt(this.$route.params.id);
    query.includes = new GetActivitiesDtosIncludeOptions();
    query.includes.activityType = true;
    query.includes.activityArea = true;
    query.includes.activityStatus = true;
    query.includes.tags = true;
    query.includes.assignees = true;
    query.includes.activityPriority = true;
    query.includes.appGroups = true;
    await this.activitiesService
      .GetSingle(query)
      .then((result: ActivityDto) => {
        this.activity = result;
        this.LoadStatus();
      })
      .catch(() => (this.activity = null));
  }

  async deleteActivity() {
    if (this.isLoading) {
      return;
    }
    if (this.activity) {
      const redirect = "/activities/list/" + this.activity.idActivityArea;
      await this.activitiesService
        .DeleteById(this.activity.idActivity || 0)
        .catch((error: any) => NotificationServiceBus.showError(error))
        .then(() => this.$router.push(redirect));
    }
  }

  async changeActivityStatus(idActivityStatus: number) {
    if (this.isLoading) {
      return;
    }
    if (this.activity) {
      this.isLoading = true;
      const command = new ChangeActivityStatusCommand();
      command.idActivity = this.activity.idActivity;
      command.idActivityStatus = idActivityStatus;
      await this.activitiesService
        .ChangeStatus(command)
        .then(() => {
          if (this.activity) {
            this.activity.idActivityStatus = idActivityStatus;
            this.activity.activityStatus = this.activityStatus.find(
              (status: ActivityStatusDto) =>
                status.idActivityStatus === idActivityStatus
            );
          }
        })
        .catch((error: any) => NotificationServiceBus.showError(error))
        .finally(() => (this.isLoading = false));
    }
  }
}
